import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=9aa21a6e&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=9aa21a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa21a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aa21a6e')) {
      api.createRecord('9aa21a6e', component.options)
    } else {
      api.reload('9aa21a6e', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=9aa21a6e&scoped=true&", function () {
      api.rerender('9aa21a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8MoZ2adRwiYg9/JS/comp/GuestBoxKids.vue"
export default component.exports